import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ContentReplacePipe } from './content-replace.pipe';

@NgModule({
  declarations: [ContentReplacePipe],
  imports: [CommonModule],
  exports: [ContentReplacePipe]
})
export class ContentReplaceModule {}
